import * as _ from 'underscore'

export type TranslationCategory = 'Forum' | 'Control' | 'Common'

type PhraseMap = Record<string, string>
type TranslationsDict = {
  [category: string]: PhraseMap
}

export type TranslationParameters = {
  [key: string]: string
} | undefined

var translationsDict: TranslationsDict = {}

function parseSingularPlural (translation: string, param: unknown): string {
  if (translation.match('::phrase::')) return translation
  var translationSingularPlural = translation.split('|')
  if (param === 1) {
    return _.first(translationSingularPlural) || ''
  }
  return _.last(translationSingularPlural) || ''
}

function translateInternal (category: TranslationCategory, key: string, params: TranslationParameters) {
  params = params || {}

  var categoryTranslations = translationsDict[category] || {}
  var hasTranslation = !!categoryTranslations[key]
  var translation = categoryTranslations[key] || key

  translation = parseSingularPlural(
    translation,
    parseInt(_.first(_.values(params)) || '', 10)
  )

  _.each(params, function (value: string | undefined, paramKey: string) {
    translation = translation.split('{' + paramKey + '}').join(value || '')
  })

  if (!hasTranslation) {
    translation = category + '|' + translation
  }

  return { translation, hasTranslation }
}

export const addTranslation = function (category: TranslationCategory, key: string, translation: string) {
  translationsDict[category] = translationsDict[category] || {}
  translationsDict[category][key] = translation
}

export const addTranslationDict = function (dict: TranslationsDict | undefined) {
  if (!dict) return
  for (var category in dict) {
    translationsDict[category] = Object.assign({}, translationsDict[category], dict[category])
  }
}

export const translateOrEmpty = function (category: TranslationCategory, key: string, params?: TranslationParameters) {
  const { hasTranslation, translation } = translateInternal(category, key, params)
  if (!hasTranslation) return ''
  return translation
}

export const translate = function (category: TranslationCategory, key: string, params?: TranslationParameters) {
  return translateInternal(category, key, params).translation
}

export const t = translate

export default {
  addTranslation,
  addTranslationDict,
  translateOrEmpty,
  translate,
  // short alias
  t: translate
}
